// NAVIGATION CONSTANTS
export var HAMBURGER = 'HAMBURGER';
export var HORIZONTAL = 'HORIZONTAL';
export var TOPLEVEL = 'TOPLEVEL';
export var SUBLEVEL = 'SUBLEVEL';
